/**
 * モーダルローディング
 */

const actions = {
  /**
   * モーダル表示
   * @param obj args
   *   modalName: @/components/modal/contents/xxx.vueのコンポーネント名
   *   data: 表示する内容のデータ
   */
  showModal({ commit }, args) {
    commit('setModal', args);
  },

  /**
   * モーダル非表示
   */
  hideModal({ commit }, payload = null) {
    if (payload) {
      // 非表示時の独自処理がある場合はここに記述
      // console.log(payload);
    }
    commit('hideModal');
  },

  /** モーダルデータ更新 */
  updateData({ commit }, data) {
    commit('updateData', data);
  },
};

const mutations = {
  setModal(state, args) {
    state.modalName = args.modalName;
    if (args.data) state.data = args.data;
  },

  hideModal(state) {
    state.modalName = '';
  },

  updateData(state, data) {
    state.data = data;
  },
};

const state = {
  modalName: '',
  data: {},
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
